<script>
  import {
    store,
    results,
    getStore,
    updateServiceResult,
  } from '../../stores/store.js';
  import { notifications } from '../../stores/notifications.js';

  import Input from '../fields/Input.svelte';
  import Button from '../Button.svelte';
  import Logs from '../Logs.svelte';

  import {
    configDataIsOk,
    getConfigData,
  } from '../../utils/handleConfigData.js';

  import Api from '../../services/Api.js';

  let loader = false;

  const updateResult = (data) => {
    updateServiceResult('getService', data);
  };

  const handleClick = async () => {
    if (configDataIsOk()) {
      loader = true;

      try {
        const request = getStore('business').service?.request;
        const payload = {
          ...getConfigData(),
          url: request?.url?.trim(),
        };

        const apiResponse = await Api.post(
          '/consult/service',
          payload
        ).catch(({ response }) => response.data);

        updateResult({ ...apiResponse });
      } catch (error) {
        updateResult({ ...error });
        notifications.danger(`Houve um erro na requisição`, 2000);
      } finally {
        loader = false;
      }
    } else {
      notifications.danger(
        'Todos os campos da configuração são obrigatórios!',
        3000
      );
    }
  };
</script>

<form class="form-get-service">
  <div class="input-wrapper">
    <Input
      text="Url completa do GET (consentimento)"
      class="url-field"
      dataCy="consult-field"
      key="consultAPIField"
      bind:value={$store.business.service.request.url}
    />

    <Button on:buttonClick={handleClick} {loader} dataCy="consult-button">
      {loader ? 'Enviando' : 'Enviar'}
    </Button>
  </div>

  {#if $results?.service?.getService}
    <div class="result">
      <h3>Resultado</h3>
      <Logs logs={$results?.service?.getService} />
    </div>
  {/if}
</form>

<style>
  .form-get-service :global(.url-field) {
    flex: 1;
  }

  .form-get-service .result {
    margin-top: 1rem;
    grid-column: 1/3;
  }

  .form-get-service :global(button) {
    min-width: initial;
    margin-top: 1.6rem;
  }
  @media (max-width: 600px) {
    .form-get-service :global(button) {
      margin-top: 0;
      width: 100%;
    }
  }

  .form-get-service :global(.logs),
  .form-get-service h3 {
    margin: 0;
  }

  .form-get-service .input-wrapper {
    grid-column: 1/3;
    display: grid;
    grid-template-columns: 5fr 1fr;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
  }
  @media (max-width: 600px) {
    .form-get-service .input-wrapper {
      flex-direction: column;
      gap: 0;
    }
  }
</style>
